import { Link } from "react-router";
import visitPlan from "../../assets/provider-guide/visit-plan.png";
import visitDefinition from "../../assets/provider-guide/visit-definition.png";
import visitBenefitNetwork from "../../assets/provider-guide/visit-benefit-network.png";
import visitSupplierNetwork from "../../assets/provider-guide/visit-supplier-network.png";
import visitSupplier from "../../assets/provider-guide/visit-supplier.png";
import visitRole from "../../assets/provider-guide/visit-role.png";
import visitPractitioner from "../../assets/provider-guide/visit-practitioner.png";
import "./ProviderGuide.scss";

const STEPS = [
    {
        to: "/config/plans",
        img: visitPlan,
        alt: "A plan booklet with a shield on the cover",
        kicker: "Plans",
        when: "The member’s plan.",
        name: "In-network if it includes 101",
        join: "includes",
    },
    {
        to: "/config/network-definitions",
        img: visitDefinition,
        alt: "A list clipped to the plan naming the in-network buckets",
        kicker: "Network definitions",
        when: "Which benefit networks the plan includes.",
        name: "Puts 101 on the plan",
        join: "names",
    },
    {
        to: "/providers/networks?type=benefit&name=Core Partnership",
        img: visitBenefitNetwork,
        alt: "A shield for the in-network bucket",
        kicker: "Benefit network",
        when: "The in-network bucket.",
        name: "Core Partnership · 101",
        join: "includes",
    },
    {
        to: "/providers/networks?type=supplier&name=CHIPA",
        img: visitSupplierNetwork,
        alt: "Several clinics grouped as one contracting roster",
        kicker: "Supplier network",
        when: "The contracting roster.",
        name: "CHIPA · IPA",
        extras: [
            { to: "/providers/contracts?supplierNetworkHccId=CHIPA&networkName=CHIPA", label: "Contracts", when: "The deal. Often on the IPA, not the clinic." },
            { to: "/providers/fee-components", label: "Fee components", when: "Rate table. Allowed amount." },
        ],
        join: "has",
    },
    {
        to: "/providers/suppliers?supplierHccId=10030558",
        img: visitSupplier,
        alt: "A clinic building",
        kicker: "Suppliers",
        when: "Clinic, hospital, or group.",
        name: "All Seasons Medical Care · 10030558",
        join: "has",
    },
    {
        to: "/providers/roles?practitionerHccId=10172866",
        img: visitRole,
        alt: "A clinician at a clinic",
        kicker: "Roles",
        when: "Person at that clinic. What claims use.",
        name: "PCP · Internal Med · NPI 1831465558",
        join: "is",
    },
    {
        to: "/providers/practitioners?practitionerHccId=10172866",
        img: visitPractitioner,
        alt: "A clinician standing alone",
        kicker: "Practitioners",
        when: "The person — TIN, NPI, HCC ID.",
        name: "Hongyin Wang · 10172866",
    },
];

const Arrow = ({ label }) => (
    <div className="provider-guide__arrow" aria-hidden="true">
        <i />
        {label ? <span>{label}</span> : null}
        <i />
    </div>
);

const ProviderGuide = () => {
    return (
        <div className="container provider-guide">
            <div className="provider-guide__frame">
                <header className="provider-guide__intro">
                    <p className="provider-guide__eyebrow">Providers</p>
                    <h1>How to look up a provider</h1>
                    <p>Each box sits in the one above it. Click a box to open that list.</p>
                </header>

                <section className="provider-guide__visit">
                    <header>
                        <p className="provider-guide__eyebrow">One visit</p>
                        <h2>Hongyin Wang at All Seasons</h2>
                    </header>

                    <ol className="provider-guide__list">
                        {STEPS.map((step) => (
                            <li key={step.kicker}>
                                <Link to={step.to} className="provider-guide__card">
                                    <img src={step.img} alt={step.alt} />
                                    <span>{step.kicker}</span>
                                    <em>{step.when}</em>
                                    <strong>{step.name}</strong>
                                </Link>
                                {step.extras?.map((extra) => (
                                    <Link key={extra.to} to={extra.to} className="provider-guide__extra">
                                        <span>{extra.label}</span>
                                        <em>{extra.when}</em>
                                    </Link>
                                ))}
                                {step.join ? <Arrow label={step.join} /> : null}
                            </li>
                        ))}
                    </ol>
                </section>
            </div>
        </div>
    );
};

export default ProviderGuide;
